import { css } from "lit-element";

export const kwCarouselStyles = css`
  :host {
    display: block;
    --default-main-color: #ff7900;
    --item-margin: 10px;
    --item-offset: 0px;
    --item-width: 546px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    font: normal 14px/1.4 Helvetica, Arial, sans-serif;
  }

  .kw-carousel {
    background-color: inherit;
    color: var(--main-color, var(--default-main-color));
  }

  .btn-next-even {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 25px solid #ff6200;
    border-right: 0;
    background: none;
    color: #ff6200;
    cursor: pointer;
    font-size: 36px;
    outline: none;
    z-index: 999;
    position: absolute;
    left: 309px;
    top: 185px;
  }

  .btn-prev-even {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-right: 25px solid #ff6200;
    border-left: 0;
    background: none;
    color: #ff6200;
    cursor: pointer;
    font-size: 36px;
    outline: none;
    z-index: 999;
    position: absolute;
    left: -3px;
    top: 185px;
  }

  .btn-next {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 25px solid #ff6200;
    border-right: 0;
    background: none;
    color: #ff6200;
    cursor: pointer;
    outline: none;
    z-index: 999;
    position: absolute;
    left: 1333px;
    top: 185px;
  }

  .btn-prev {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-right: 25px solid #ff6200;
    border-left: 0;
    background: none;
    color: #ff6200;
    cursor: pointer;
    font-size: 36px;
    outline: none;
    z-index: 999;
    position: absolute;
    left: 1021px;
    top: 185px;
  }

  .border-mask {
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-bottom: 2px solid #ff6200;
    border-right: 2px solid #ff6200;
    border-left: 2px solid #ff6200;
    height: 402px;
    width: 261px;
    position: absolute;
    z-index: 9;
  }

  .border-mask-top-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-top: 2px solid rgb(255, 98, 0);
    width: 80px;
    position: absolute;
    left: 0px;
    z-index: 9;
  }

  .border-mask-top-right {
    display: flex;
    flex-direction: row;
    justify-content: center;
    border-top: 2px solid rgb(255, 98, 0);
    width: 80px;
    position: absolute;
    z-index: 9;
    left: 182px;
  }

  #contents {
    background-color: #fdfdfd;
    display: flex;
    flex: 1;
    position: relative;
    margin-bottom: 50px;
    margin-right: 5px;
  }

  #contents-even {
    display: flex;
    flex: 1;
    position: relative;
    margin-bottom: 50px;
    margin-left: 1020px;
  }

  article {
    box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
      0 1px 3px 0 rgba(63, 63, 68, 0.15);
    box-sizing: border-box;
    flex-shrink: 0;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 402px;
    min-width: 261px;
    max-width: 261px;
    background-color: #f5f5f5;
    text-align: center;
    margin: 0px 22px;
  }
  article img {
    position: relative;
    bottom: 50px;
    height: 116px;
    width: 116px;
    z-index: 99;
    margin-bottom: 20px;
  }
  .article-texts {
    margin: 0px 40px;
    margin-bottom: 20px;
  }
  .article-texts img p {
    margin-bottom: 20px;
  }
  .article-name {
    margin-top: -50px;
    color: #ff7900;
    font-weight: bold;
    margin-bottom: 40px;
  }
  .article-title {
    color: #727272;
    font-weight: bold;
    margin-top: -15px;
    margin-bottom: 40px;
  }
  .article-text {
    color: #727272;
    font-weight: 300;
    margin-top: -15px;
    margin-bottom: 40px;
  }

  @media all and (min-width: 768px) {
    .btn-next-even {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 25px solid #ff6200;
      border-right: 0;
      background: none;
      color: #ff6200;
      cursor: pointer;
      font-size: 36px;
      outline: none;
      z-index: 999;
      position: absolute;
      left: 1167px;
      top: 143px;
    }

    .btn-prev-even {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-right: 25px solid #ff6200;
      border-left: 0;
      background: none;
      color: #ff6200;
      cursor: pointer;
      font-size: 36px;
      outline: none;
      z-index: 999;
      position: absolute;
      left: 570px;
      top: 143px;
    }

    .btn-next {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 25px solid #ff6200;
      border-right: 0;
      background: none;
      color: #ff6200;
      cursor: pointer;
      outline: none;
      z-index: 999;
      position: absolute;
      left: 2347px;
      top: 143px;
    }

    .btn-prev {
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-right: 25px solid #ff6200;
      border-left: 0;
      background: none;
      color: #ff6200;
      cursor: pointer;
      font-size: 36px;
      outline: none;
      z-index: 999;
      position: absolute;
      left: 1750px;
      top: 143px;
    }

    .border-mask {
      display: flex;
      flex-direction: row;
      justify-content: center;
      border-bottom: 2px solid #ff6200;
      border-right: 2px solid #ff6200;
      border-left: 2px solid #ff6200;
      height: 320px;
      width: 546px;
      position: absolute;
      z-index: 9;
    }

    .border-mask-top-left {
      display: flex;
      flex-direction: row;
      justify-content: center;
      border-top: 2px solid rgb(255, 98, 0);
      width: 220px;
      position: absolute;
      left: 0px;
      z-index: 9;
    }

    .border-mask-top-right {
      display: flex;
      flex-direction: row;
      justify-content: center;
      border-top: 2px solid rgb(255, 98, 0);
      width: 222px;
      position: absolute;
      z-index: 9;
      left: 325px;
    }

    #contents {
      display: flex;
      flex: 1;
      position: relative;
      margin-bottom: 50px;
    }

    #contents-even {
      display: flex;
      flex: 1;
      position: relative;
      margin-bottom: 50px;
      margin-left: 585px;
    }

    #contents::after {
      background: linear-gradient(
        to right,
        #fff 0%,
        transparent 3%,
        transparent 97%,
        #fff 100%
      );
      content: "";
      position: relative;
      height: 100%;
      width: 100%;
    }

    article {
      box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
        0 1px 3px 0 rgba(63, 63, 68, 0.15);
      box-sizing: border-box;
      flex-shrink: 0;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 320px;
      min-width: 546px;
      max-width: 546px;
      background-color: #f5f5f5;
      text-align: center;
      margin: 0px 22px;
    }
    article img {
      position: relative;
      bottom: 50px;
      height: 116px;
      width: 116px;
      z-index: 99;
      margin-bottom: 20px;
    }
    .article-texts {
      margin: 0px 22px;
      margin-bottom: 20px;
    }
    .article-texts img p {
      margin-bottom: 20px;
    }
    .article-name {
      margin-top: -50px;
      color: #ff7900;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .article-title {
      color: #727272;
      font-weight: bold;
      margin-top: -15px;
      margin-bottom: 40px;
    }
    .article-text {
      color: #727272;
      font-weight: 300;
      margin-top: -15px;
      margin-bottom: 40px;
    }
  }
`;
